import React from 'react'
import styles from './GlobalFooter.scss'
import cx from 'classnames'
import { Msg, featureNames } from 'lib/localization'
import { FormattedMessage as T, defineMessages } from 'react-intl'

export const messages = defineMessages({
  helpCenter: {
    id: 'globalFooter.help',
    defaultMessage: 'Help Center'
  }
})

const YEAR = new Date().getFullYear()

export const GlobalFooter = ({ className }) => (
  <div className={cx(styles.GlobalFooter, className)}>
    <div className={styles.logo}>
      <a href='/'>
        <img src='/images/revised_layout/logo.png' />
      </a>
      <div className={styles.slogan}>
        <T
          id='globalFooter.slogan'
          defaultMessage='Get Inspired, Not Lost'
          description='Our company slogan' />.  © {YEAR} Ride with GPS.
        <a href='/terms'>
          <T id='globalFooter.terms' defaultMessage='Terms of Service' />
        </a>.
        <a href='/privacy'><T id='globalFooter.privacy' defaultMessage='Privacy Policy' />
        </a>.
      </div>
    </div>
    <div className={styles.nav}>
      <ul>
        <li>
          <a href='/app'><Msg m={featureNames.mobileApp} /></a>
        </li>
        <li>
          <a href='/app/mobile_route_planner'><Msg m={featureNames.mobileRoutePlanner} /></a>
        </li>
        <li>
          <a href='/route_planner'><Msg m={featureNames.webRoutePlanner} /></a>
        </li>
        <li>
          <a href='/integrations'><Msg m={featureNames.integrations} /></a>
        </li>
      </ul>
      <ul>
        <li>
          <a href='/organizations'><Msg m={featureNames.organizations} /></a>
        </li>
        <li>
          <a href='/experiences'><Msg capitalized m={featureNames.experiences} values={{ count: 0 }} /></a>
        </li>
        <li>
          <a href='/organizations/clubs'><T id='globalFooter.cyclingClubs' defaultMessage='Cycling Clubs' /></a>
        </li>
        <li>
          <a href='/organizations/events/experiences'><T id='globalFooter.cyclingEvents' defaultMessage='Cycling Events' /></a>
        </li>
      </ul>
      <ul>
        <li>
          <a href='/about'><T id='globalFooter.about' defaultMessage='About Us' /></a>
        </li>
        <li>
          <a href='/careers'><T id='globalFooter.careers' defaultMessage='Careers' /></a>
        </li>
        <li>
          <a href='/contact'><T id='globalFooter.contact' defaultMessage='Contact' /></a>
        </li>
        <li>
          <a href='/help'><Msg m={messages.helpCenter} /></a>
        </li>
      </ul>
      <ul>
        <li>
          <a href='https://www.facebook.com/ridewithgps'>Facebook</a>
        </li>
        <li>
          <a href='https://www.twitter.com/ridewithgps'>Twitter</a>
        </li>
        <li>
          <a href='https://www.instagram.com/ridewithgps'>Instagram</a>
        </li>
        <li>
          <a href='https://www.youtube.com/ridewithgps'>YouTube</a>
        </li>
      </ul>
    </div>
  </div>
)
